import http from '@/utils/http'

const fetch = ({ token }) => http()
  .get(`/platforms/${token}`)

const save = ({ data, token }) => http()
  .put(`/platforms/${token}`, data)

export default {
  fetch,
  save
}



// WEBPACK FOOTER //
// ./src/api/platform.js